import { render, staticRenderFns } from "./CourseSeriesDetails.vue?vue&type=template&id=78535e84&scoped=true&"
import script from "./CourseSeriesDetails.vue?vue&type=script&lang=js&"
export * from "./CourseSeriesDetails.vue?vue&type=script&lang=js&"
import style0 from "./CourseSeriesDetails.vue?vue&type=style&index=0&id=78535e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78535e84",
  null
  
)

export default component.exports